import {defineMessages} from 'react-intl';

export const quizMessages = defineMessages({
  blindTest: { id: 'quiz.blind_test' },
  clickLocation: {
    id: 'quiz.click_location',
  },
  close: { id: 'quiz.close' },
  correct: { id: 'quiz.correct' },
  dontShowAgain: { id: 'quiz.dont_show_again' },
  failMessage: { id: 'quiz.fail_message' },
  go: { id: 'quiz.go' },
  passedMessage: { id: 'quiz.passed_message' },
  quiz: { id: 'quiz.quiz' },
  scoreCalc: {
    id: 'quiz.score_calc',
  },
  scoreExplanation: {
    id: 'quiz.score_explanation',
  },
  submit: { id: 'quiz.submit' },
  showSolution: { id: 'quiz.show_solution' },
  showTheirAnswer: { id: 'quiz.show_their_answer' },
  successMessage: { id: 'quiz.success_message' },
  tryAgain: { id: 'quiz.try_again' },
  scoreBelowSuccessRate: {
    id: 'quiz.score_below_success_rate',
  },
});
